'use client';
import ServicesItem from '@/components/library/ServicesItem';
import ServicesList from '@/components/library/ServicesList';
import "@/styles/components/library/services.css";
import iconWebsite from '@/icons/icon-service-website.png';
import iconEmail from '@/icons/icon-service-email.png';
import iconBanner from '@/icons/icon-service-banner.png';
import iconAccessibility from '@/icons/icon-service-accessibility.png';
import iconSEO from '@/icons/icon-service-seo.png';
import iconAudit from '@/icons/icon-service-audit.png';
import iconDesign from '@/icons/icon-service-design.png';

const Services = () => {
  return (
    <div className="services">
      <aside className="services__list">
        <h3>Skills</h3>
        
        <ServicesList
          heading="Core web technologies"
          list={['Semantic HTML', 'CSS (SCSS)', 'JavaScript (ES6+)', 'Typescript', 'PHP', 'MySQL']}
        />

        <ServicesList
          heading="Frameworks & Libraries"
          list={['Next.js', 'React', 'Nuxt', 'Vue', 'jQuery', 'Tailwind', 'Bootstrap', 'Foundation', 'GSAP']}
        />

        <ServicesList
          heading="Development Tools"
          list={['Git & GitHub', 'Parcel', 'Rollup', 'Vite', 'Webpack']}
        />

        <ServicesList
          heading="AI"
          list={['ChatGPT', 'Claude', 'Copilot', 'Deepseek', 'Gemini', 'Grok', 'Perplexity']}
        />

        <ServicesList
          heading="CMS & E-commerce Platforms"
          list={['Shopify', 'Squarespace', 'WordPress', 'ExpressionEngine']}
        />

        <ServicesList
          heading="Design, Animation & User Experience"
          list={['UI/UX Design Principles', 'Usability & Accessibility (WCAG)', 'Responsive Design', 'Core Web Vitals', 'SEO (Search Engine Optimization)', 'Social Media Integration', 'Design Tools (Affinity Designer, Adobe Photoshop, Adobe XD, Figma, Sketch) ']}
        />

        <ServicesList
          heading="Best Practices & Standards"
          list={['Web Standards Compliance', 'Accessibility (WCAG Guidelines)', 'Progressive Enhancement', 'Cross-browser Compatibility', 'Mobile-first Approach']}
        />
      </aside>

      <div className="services__info">
        <ServicesItem
          icon={iconWebsite}
          heading="Websites"
          copy={<><p>Delivering <strong>professional front-end solutions</strong> that combine speed, accessibility, and modern technologies with <strong>clean semantic code</strong>. With 20+ years of industry experience, I transform designs into exceptional user experiences that load instantly and work for everyone. My dedication to web accessibility ensures <strong>WCAG compliance across all projects</strong>, creating inclusive experiences that meet industry standards and legal requirements. My meticulous approach and technical expertise ensure your website not only looks stunning but performs flawlessly to drive real business results.</p></>}
          alt="Desktop and mobile device screens collection"
        />

        <ServicesItem
          icon={iconEmail}
          heading="Emails"
          copy={<><p>Crafting pixel-perfect emails that render flawlessly across all email clients and devices. Every campaign is <strong>rigorously tested across 100+ email platforms</strong> to ensure consistent display, optimal deliverability, and maximum engagement. Emails work seamlessly with popular email marketing platforms such as <strong>MailChimp, Marketo, and Campaign Monitor</strong> turning your message into measurable results without the technical headaches that plague most email development.</p></>}
          alt="Letter coming out of an envelope with @ text"
        />

        <ServicesItem
          icon={iconBanner}
          heading="Banners"
          copy={<><p>Developing eye-catching digital banners that drive conversions across <strong>Google Display Network</strong> and <strong>Flashtalking</strong>. My portfolio includes both elegant static designs and dynamic animated creatives that capture attention while maintaining brand consistency. Each banner is optimized for performance, ensuring your message stands out effectively on every platform without technical issues or delays.</p></>}
          alt="Simuldated desktop screen showing play button with stars to the side"
        />
        
        <ServicesItem
          icon={iconAccessibility}
          heading="Accessibility (WCAG)"
          copy={<><p>I transform websites to meet <strong>WCAG guidelines</strong> through <strong>detailed accessibility audits</strong> and implementation of best practices. My expertise ensures <strong>digital inclusion</strong> with proper semantic markup, keyboard navigation, and screen reader compatibility. I identify <strong>critical issues</strong> and provide <strong>clear remediation paths</strong>, protecting your business from legal exposure while expanding your audience to include the 15% of global population with disabilities.</p></>}
          alt="Laptop with accesibilty person icon and WCAG text"
        />

        <ServicesItem
          icon={iconSEO}
          heading="SEO"
          copy={<><p>Delivering <strong>professional SEO optimization</strong> with <strong>data-driven results</strong>. I transform websites to rank higher through technical expertise and senior front-end development knowledge. My work ensures <strong>superior Core Web Vitals scores</strong> that meet Google's standards. Meticulous implementation of schema markup and <strong>semantic HTML</strong> makes your site prominent in search results, <strong>converting visibility into business growth</strong>.</p></>}
          alt="Desktop with SEO text and a magnifying glass"
        />

        <ServicesItem
          icon={iconAudit}
          heading="Audits"
          copy={<><p>I deliver <strong>comprehensive website audits</strong> identifying performance bottlenecks and optimization opportunities. My technical assessment pinpoints issues affecting speed, experience, and conversions. I analyze Core Web Vitals, rendering, asset delivery, and code efficiency to create a <strong>clear improvement roadmap</strong>. My expertise transforms challenges into <strong>actionable solutions</strong> that enhance page load times, turning sluggish sites into fast experiences that <strong>retain visitors and boost revenue</strong>.</p></>}
          alt="Desktop with a magnifying glass with a tick icon inside"
        />

        <ServicesItem
          icon={iconDesign}
          heading="Design"
          copy={<><p>Crafting <strong>visually stunning websites</strong> that captivate and convert through expert design execution. I leverage industry-leading tools — Adobe Photoshop, Adobe XD, Affinity, Sketch, and Figma to transform your brand vision into <strong>polished digital experiences</strong>. Every element is crafted with <strong>pixel-perfect precision</strong>, ensuring seamless responsiveness across all devices while balancing aesthetic appeal and functional usability that <strong>drives meaningful user engagement</strong>.</p></>}
          alt="Desktop with a pen, vector tool and text icons"
        />
      </div>
    </div>
  )
}

export default Services;
